import { render, staticRenderFns } from "./section.vue?vue&type=template&id=3026f7a2&scoped=true&"
import script from "./section.vue?vue&type=script&lang=ts&"
export * from "./section.vue?vue&type=script&lang=ts&"
import style0 from "./section.vue?vue&type=style&index=0&id=3026f7a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3026f7a2",
  null
  
)

export default component.exports